import React, { Component } from 'react';
import { EditorState, convertToRaw, convertFromRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { EditorStyled } from './Editor.styled';
import { subirImagen } from '../CartelUpload';

async function uploadImage(file) {
  // Misma subida que el cartel (tiempo límite y errores de la API); un rechazo lo gestiona el editor.
  const result = await subirImagen(file)
  // Custom object for DrafJS
  const data = { data: { link: result } }
  return data;
}

class TextEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    if (this.props.editorState) {

      let contentState;
      const containsHTMLTags = /<[^>]*>/.test(this.props.editorState);

      if (containsHTMLTags) {
        // Si contiene etiquetas HTML, quitarlas y crear ContentState a partir del texto sin formato.
        const strippedText = this.stripHTMLTags(this.props.editorState);
        contentState = ContentState.createFromText(strippedText);
      } else if (this.isValidJSON(this.props.editorState)) {
        try {
          // Intenta parsear como JSON y convertir a ContentState
          const parsedData = JSON.parse(this.props.editorState);
          contentState = convertFromRaw(parsedData);
        } catch (error) {
          console.error("Error parsing editorState:", error);
        }
      } else {
        // Si no es ni HTML ni JSON válido, tratar como texto sin formato.
        contentState = ContentState.createFromText(this.props.editorState);
      }

      if (contentState) {
        this.state.editorState = EditorState.createWithContent(contentState);
        this.saveContent(this.state.editorState.getCurrentContent());
      }
    } else {
      // Formulario nuevo o sin texto: no reutilizar el borrador de otro formulario abierto antes.
      window.localStorage.removeItem('draftjs-content');
    }
  }

  isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  stripHTMLTags(input) {
    return input.replace(/<[^>]+>/g, '');
  }

  saveContent = (content) => {
    window.localStorage.setItem('draftjs-content', JSON.stringify(convertToRaw(content)));
  }

  onEditorStateChange = (editorState) => {
    const contentState = editorState.getCurrentContent();
    this.saveContent(contentState);
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    return <EditorStyled>
      <Editor
        editorState={editorState}
        onEditorStateChange={this.onEditorStateChange}
        toolbar={{
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
          image: { uploadCallback: uploadImage, alt: { present: true, mandatory: false } },
        }}
      />
    </EditorStyled>
  }
}

export default TextEditor;